export const faqs = [
  {
    q: 'Bu sistem yeni başlayanlar için de uygun mu?',
    a: [
      'Sistem, hazırlığı aşamalara ayıran bir yapı sunar. TEMEL aşamasından başlayarak diğer aşamalara doğru ilerleyen bir hazırlık çerçevesi sağlar.',
      'Bununla birlikte, uzun mesafe triatlonu ciddi fiziksel hazırlık gerektirir. Antrenman seviyenizi ve sağlık durumunuzu dikkate almanız önemlidir.',
    ],
  },
  {
    q: 'Sistemi kullanmak için bir antrenöre ihtiyacım var mı?',
    a: [
      'Sistem, hazırlığınızı organize etmenize yardımcı olan dijital bir rehberdir. Kişiye özel antrenörlük hizmeti değildir.',
      'Bireysel ihtiyaçlarınız, deneyiminiz veya sağlık durumunuz gerektiriyorsa bir antrenörden ya da uygun bir sağlık uzmanından destek alabilirsiniz.',
    ],
  },
  {
    q: 'Spor salonuna gitmem gerekiyor mu?',
    a: [
      'Sistem, hazırlık sürecini organize etmeye yönelik bir çerçeve sunar. Belirli bir spor salonuna üyelik, ürünün temel erişim koşulu olarak sunulmamaktadır.',
      'Uygulayacağınız çalışmalar için ihtiyaç duyduğunuz ekipman, hedeflerinize ve antrenman planınıza bağlıdır.',
    ],
  },
  {
    q: 'Bu fiziksel bir kitap mı?',
    a: ['Hayır. Ürün dijital formatta sunulur. Fiziksel kitap veya basılı materyal gönderimi yapılmaz.'],
  },
  {
    q: 'Tek seferlik ödeme mi yapıyorum?',
    a: ['Evet. Belirtilen ürün fiyatı 1.330 TRY olup tek seferlik ödemedir.'],
  },
  {
    q: 'İçeriğe nasıl erişebilirim?',
    a: [
      'Satın alma işleminiz ve dijital teslimat süreciniz tamamlandıktan sonra ürünün dijital içeriğine erişebilirsiniz. Erişim ayrıntıları satın alma sırasında belirtilen teslimat yöntemi üzerinden iletilir.',
    ],
  },
  {
    q: 'Dört bonus da ürüne dahil mi?',
    a: [
      'Evet. Aşağıdaki dört bonus ana ürünle birlikte ücretsiz olarak sunulur:',
      '40 HAFTALIK TRİATLON ANTRENMAN TAKVİMİ™ · TRİATLON BESLENME REHBERİ™ · YARIŞ HAFTASI KONTROL MERKEZİ™ · TRİATLON GELİŞİM TAKİP ÇİZELGESİ™',
    ],
  },
  {
    q: 'Telefonumda, tabletimde veya bilgisayarımda kullanabilir miyim?',
    a: [
      'Dijital içeriği, dosya formatı ve kullandığınız cihaz desteklediği sürece uyumlu telefon, tablet ve bilgisayar üzerinden kullanabilirsiniz.',
    ],
  },
  {
    q: 'Bu ürün kişiye özel antrenörlük hizmeti mi?',
    a: [
      'Hayır. UZUN MESAFE TRİATLON SİSTEMİ™, hazırlığınızı organize etmenize yardımcı olan dijital bir sistemdir.',
      'Kişiye özel antrenman takibi, bire bir koçluk veya kişisel sağlık değerlendirmesi içerdiği iddia edilmemektedir.',
    ],
  },
];

export const steps = [
  {
    n: '1',
    title: 'Dijital erişiminizi alın',
    body: 'UZUN MESAFE TRİATLON SİSTEMİ™ ürününü satın alın ve ana dijital içeriğe ve dört bonusunuza erişin. Kargo beklemeniz gerekmez. Dijital içeriğinize eriştikten sonra kendi programınıza uygun şekilde çalışmaya başlayabilirsiniz.',
    tags: [] as string[],
    after: '',
  },
  {
    n: '2',
    title: 'Antrenman sisteminizi oluşturun',
    body: 'Altı aşamayı inceleyin ve hazırlığınızı şu başlıklar etrafında organize edin:',
    tags: ['Yüzme', 'Bisiklet', 'Koşu', 'Kuvvet çalışmaları', 'Toparlanma', 'Beslenme', 'İlerleme takibi'],
    after: 'Sürekli “Sırada ne yapmalıyım?” diye düşünmek yerine, hazırlığınızı organize etmek için kullanabileceğiniz yapılandırılmış bir çerçeveye sahip olun.',
  },
  {
    n: '3',
    title: 'Yarışınızı planlı şekilde uygulayın',
    body: 'Yarış günü yaklaştıkça, sistemle birlikte gelen bonusları kullanarak şu konuları organize edin:',
    tags: ['Antrenman planınız', 'Beslenme yaklaşımınız', 'Gelişim takibiniz', 'Ekipmanınız', 'Yarış haftanız', 'Yarış günü uygulamanız'],
    after: '',
  },
];
